module.exports = __webpack_public_path__ + "static/media/Basculin_gaussian2.edf00a8e.png";